import { render, staticRenderFns } from "./file-view-dialog.vue?vue&type=template&id=436b4d4c&scoped=true&"
import script from "./file-view-dialog.vue?vue&type=script&lang=js&"
export * from "./file-view-dialog.vue?vue&type=script&lang=js&"
import style0 from "./file-view-dialog.vue?vue&type=style&index=0&id=436b4d4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436b4d4c",
  null
  
)

export default component.exports